import store from "../store"
import Emitter from "./Emitter"
import { Sniffer, lerp } from "../utils/index"
import { gsap, ScrollTrigger } from "../libraries/gsap/index"

export default class Raf {
  constructor() {
    this.scroll = {
      target: 0,
      current: 0,
      rounded: 0,
      ease: 0.115,
    }

    this.mouse = {
      x: 0,
      y: 0,
      target: null,
    }

    this.setScrollTrigger()
    this.on()
  }

  tick = () => {
    const { target, current, ease } = this.scroll
    this.scroll.current = lerp(current, target, ease)
    this.scroll.rounded = Math.round(current * 100) / 100
    this.diff = (target - current) * 0.005

    Emitter.emit("tick", {
      target: target,
      current: this.smooth(),
      mouse: this.mouse,
      diff: this.diff,
    })

    ScrollTrigger.update()
  }

  clamp() {
    const { fh } = store.page

    this.scroll.target = Math.min(Math.max(this.scroll.target, 0), fh)
  }

  smooth() {
    const { contentPage } = store

    if (!Sniffer.sniff.isDevice) {
      return this.scroll.rounded
    } else {
      return contentPage.parentNode.scrollTop
    }
  }

  onScroll = ({ y }) => {
    const { isLocked } = store.flags

    if (isLocked) return
    this.scroll.target += y
    this.clamp()
  }

  setScroll(offset) {
    const { isSmooth } = store.flags

    if (isSmooth) {
      gsap.set(this.scroll, {
        target: offset,
        current: offset,
        rounded: offset,
      })
      gsap.to(this, {
        original: offset,
        duration: 1,
        ease: "expo.inOut",
      })
    } else {
      window.scrollTo({
        top: offset,
        left: 0,
      })
    }
  }
  scrollTo(offset) {
    const { isSmooth } = store.flags

    if (isSmooth) {
      gsap.to(this.scroll, {
        target: offset,
        duration: 1,
        ease: "expo.inOut",
      })
    } else {
      window.scrollTo({
        top: offset,
        left: 0,
        behavior: "smooth",
      })
    }
  }

  move = ({ x, y, target }) => {
    this.mouse.x = x
    this.mouse.y = y
    this.mouse.target = target
  }

  setScrollTrigger() {
    const { contentPage } = store

    ScrollTrigger.defaults({
      scroller: contentPage,
    })

    ScrollTrigger.scrollerProxy(contentPage, {
      scrollTop: () => {
        return this.smooth()
      },
      getBoundingClientRect() {
        // Important that width and height are dynamic
        return { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight }
      },
    })
  }

  on() {
    gsap.ticker.add(this.tick)
    Emitter.on("scroll", this.onScroll)
    Emitter.on("mousemove", this.move)
  }
}
